import { createLucideIcon } from 'lucide-react';
export const IconsTags = createLucideIcon('icons-tags', [
  [
    'path',
    {
      d: 'M10.4118 4L3 11.4118L9.17647 18L17 10.1765V4H10.4118Z',
      key: 'y2xbin',
    },
  ],
  [
    'path',
    {
      d: 'M11 19.125L11.9 20L20 12.125V6H18.65',
      key: 'yxfoav',
    },
  ],
  [
    'circle',
    {
      cx: '13.5',
      cy: '6.5',
      r: '0.5',
      fill: 'var(--contrast)',
      key: 'kzew4z',
    },
  ],
]);
